import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import VideoIcon from '@atlaskit/icon/core/video';
import Button, { IconButton } from '@atlaskit/button/new';
import { Box, Inline, Text, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { LoomIcon } from '@atlaskit/logo';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';

import { messages } from '../messages';

import { ViewScriptButton } from './ViewScriptButton';
import { LoomScriptInfoPopup } from './InfoPopup';

const marginTop = xcss({
	marginTop: 'space.100',
});
const marginBottom = xcss({
	marginBottom: 'space.100',
});

const loomIconStyles = xcss({
	width: '20px',
	height: '20px',
	marginLeft: 'space.negative.025',
	marginRight: 'space.075',
});

const HorizontalDivider = xcss({
	borderBottom: `1px solid ${token('color.border')}`,
	height: '1px',
	width: '135px',
});

export const ReadTimeDropdownLoomScriptExtension = () => {
	return (
		<>
			<Box key="loomAIScriptSectionLabel" xcss={marginBottom}>
				<Inline alignBlock="center" spread="space-between">
					<Text color="color.text.subtlest" size="small">
						<FormattedMessage {...messages.readTimeImprovementLabel} />
					</Text>
					<Box xcss={HorizontalDivider} />
				</Inline>
			</Box>

			<Box key="createSummaryLoomVideo" xcss={[marginTop, marginBottom]}>
				<Inline alignBlock="center" spread="space-between">
					<Inline alignBlock="center">
						<Flex alignItems="center" justifyContent="center" xcss={loomIconStyles}>
							<LoomIcon appearance="brand" size="small" />
						</Flex>
						<Box xcss={[marginTop, marginBottom]}>
							<Text weight="bold" size="medium">
								<FormattedMessage {...messages.readTimeLoomAIScriptTitle} />
							</Text>
						</Box>
					</Inline>
					<LoomScriptInfoPopup
						trigger={({ isOpen, togglePopup, triggerProps }) => (
							<IconButton
								{...triggerProps}
								icon={InformationCircleIcon}
								label="View script value"
								appearance="subtle"
								spacing="compact"
								isSelected={isOpen}
								onClick={togglePopup}
							/>
						)}
					/>
				</Inline>
			</Box>

			<Box key="loomAIScriptCTA" xcss={marginTop}>
				<Flex alignItems="center" justifyContent="start" gap="space.100">
					<Button iconBefore={VideoIcon}>
						<FormattedMessage {...messages.openRecorder} />
					</Button>
					<ViewScriptButton />
				</Flex>
			</Box>
		</>
	);
};
